<template>
	<div>
		<ion-item class="ion-no-padding ion-no-margin ion-margin-vertical cmf-input-wrapper ion-text-left" >
			<ion-label :position="labelPosition" class="fw-bold">{{label}}</ion-label>
			<ion-textarea
				v-model="fieldData"
				:disabled="readonly"
				:type="inputType"
				:placeholder="placeholder"
				@ionChange="changed($event)"/>
			<div class="toggle-password" v-if="togglePassword">
				<ion-icon @click="inputType = 'password' " v-if="inputType == 'text'" :icon="icons.eyeOutline"></ion-icon>
				<ion-icon @click="inputType = 'text' " v-else :icon="icons.eyeOffOutline"></ion-icon>
			</div>
			<div v-if="(modelValue.$dirty ) || (vBe && vBe[name])" slot="end">
				<img v-if="!hasError" src="../_assets/img/check-input.svg" alt="">
				<img v-if="hasError" src="../_assets/img/x-input.svg" alt="">
			</div>
		</ion-item>
		<!--FE ERRORS-->
		<div v-if="modelValue.$error && modelValue.$dirty" class="ion-no-margin">
			<div class="error" v-for="(error, index) in modelValue.$errors" :key="index">
				{{validationErrors[error.$validator]}}
			</div>
		</div>
		<!--BE ERRORS -->
		<div v-if="vBe && typeof vBe == 'object'">
			<div class="error" v-for="(error, index) in vBe[name]"  :key="index">
				{{displayError(error)}}
			</div>
		</div>

	</div>
</template>

<script>
import {eyeOutline, eyeOffOutline, cloudyNight } from 'ionicons/icons'
import utils from '@/plugins/w/toast/utils'
export default {
	emits: ['update:modelValue'],
	props: {
		modelValue: Object,
		label: {
			required: false,
			default: ''
		},
		type: {
			type: String,
			required: false,
			default: 'text'
		},
		togglePassword: {
			type: Boolean,
			default: false
		},
		placeholder: {
			type: String,
			required: false,
			default: ''
		},
		readonly: {
			type: Boolean,
			required: false,
			default: false
		},
		labelPosition: {
			type: String,
			required: false,
			default: 'floating'
		},
		vBe: {
			required: false,
		},
	},
	computed: {
		hasError() {
			if ( this.vBe && this.vBe[this.name]) {
				return true
			} else if (this.modelValue.$dirty && this.modelValue.$error) {
				return true
			}

			return false
		}
	},
	data(){
		return{
			inputType: '',
			fieldData: null,
			name: '',
			validationErrors: {
				required: 'This field is mandatory.',
				email: 'Please enter valid email.',
				numeric: 'Field value must be number.',
				minLength: `This field needs to be at least ${this.modelValue.minLength ? this.modelValue.minLength.$params.min : ' '} characters long.`,
				maxLength: `This field is limited to ${this.modelValue.maxLength ? this.modelValue.maxLength.$params.max : ' '} characters.`,
				sameAsPassword: 'Passwords does not match.',
				agreed: 'You need to accept terms first.'
			},
			icons: {
				eyeOutline,
				eyeOffOutline
			},
		}
	},
	mounted() {
		this.name = this.modelValue.$path.split('.').pop()
		this.inputType = this.type
		this.fieldData = this.modelValue.$model
	},
	methods: {
		changed(e) {
			this.eventBus.emit('input', this.name)

			//idk if its the best solution but it does what $set() used to do
			let newValue = this.modelValue
			newValue.$model = e.target.value
			this.$emit('update:modelValue', newValue)
		},
		displayError(error) {
			return utils.parseToString(error)
		}
	},
	watch:{
		modelValue: {
			deep: true,
			handler: function(data) {
				this.fieldData = data.$model
			}
		},
	}
}
</script>

<style lang="sass">
.native-textarea
	height: 90px!important

</style>

<style lang="sass" scoped>


.cmf-input-wrapper
	position: relative
	margin-bottom: 10px

	ion-textarea
		height: 90px

		

	img
		position: absolute
		right: 10px
		bottom: 50%
		z-index: 20

	.toggle-password
		position: absolute
		right: 30px
		bottom: 5px
		z-index: 20

	.error
		color: red
</style>
